/**
 * Listas "não considerados | considerados" do critério de rateio. So move ids (nenhuma conta sobre valores).
 * A lista "considerados" e ordenada e vira `centroIds` no envio; a "não considerados" e o restante do universo.
 */

export type LadoCentro = 'considerados' | 'naoConsiderados';

export interface CentroEscolha {
  id: string;
  /** "caminho · nome", como vem de GET /centros-custo/analiticos (`rotulo`). */
  rotulo: string;
}

export interface ListasCentros {
  considerados: string[];
  naoConsiderados: string[];
}

/** Ids unicos, na ordem da primeira aparicao. */
function unicos(ids: readonly string[]): string[] {
  return [...new Set(ids)];
}

/** Divide o universo nas duas listas. `considerados` mantem a ordem recebida (so ids do universo); o resto segue a ordem do universo. */
export function listasDe(universo: readonly string[], considerados: readonly string[]): ListasCentros {
  const noUniverso = new Set(universo);
  const escolhidos = unicos(considerados).filter((id) => noUniverso.has(id));
  const marcados = new Set(escolhidos);
  return { considerados: escolhidos, naoConsiderados: universo.filter((id) => !marcados.has(id)) };
}

/**
 * Move `ids` para `destino` e devolve a nova lista de considerados (ordem final = centroIds).
 * `antesDe` (opcional, so para destino "considerados"): insere antes desse id; sem ele, vai para o fim.
 */
export function moverCentros(
  considerados: readonly string[],
  universo: readonly string[],
  ids: readonly string[],
  destino: LadoCentro,
  antesDe?: string,
): string[] {
  const noUniverso = new Set(universo);
  const movidos = unicos(ids).filter((id) => noUniverso.has(id) && id !== antesDe);
  const sem = considerados.filter((id) => !movidos.includes(id));
  if (destino === 'naoConsiderados') return sem;
  const posicao = antesDe !== undefined ? sem.indexOf(antesDe) : -1;
  if (posicao < 0) return [...sem, ...movidos];
  return [...sem.slice(0, posicao), ...movidos, ...sem.slice(posicao)];
}
